import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Link } from "gatsby";
import Layout from "gatsby-theme-cooper-hewitt/src/components/mdx-default-layout";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "about-chris-rotunno"
    }}>{`About Chris Rotunno`}</h1>
    <p>{`This blog is designed to reach `}<em parentName="p">{`web developers, technical recruiters, and investors of technology`}</em>{` as well as anyone else who might be interested in business software.
I aim to have an online product for people to judge for themselves—independent of social media.
I encourage everyone to check out my posts and to `}<a parentName="p" {...{
        "href": "https://mailchi.mp/ba70d1717e4c/rotunno"
      }}>{`watch for monthly newsletters`}</a>{` with updates and fresh new content.`}</p>
    <hr></hr>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1036px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABcRAAAXEQHKJvM/AAAEFElEQVQ4yzWSXUybZRTH37vFK3exhajRGBO98Ea9cBcu08Rl0ajBKdmglI+y0hZaGCX0m5aW8t2VtqMTLAhlGx9j7cN4lY85xoQRGRTKCyuldHwMJmNuLvHCq2VPn+N5a7z455znyfP/nf9583KBUETfGV4c7x5eCqHI1Z+jZOK3GJmdT5DpuQS5dTdOyK8rpDMcIcGRKJmJbJP5lV0yJzwkE7MbZOxuggT5aHjw5spIZHXXzc1EtsbXd/8BIfEnLCeewuT8LoRvJ2F4KgmhyQ3oG4+j1mEqsgfxreewvPEMhqc34dpkAgZR/TfjELixDHeW9uH36E6SW0sehLb2/obYxuMX2NP1zSd0ZX2fLsUe0YXVPTq7uE3nhYd0NbFPhfgfdOn+Xlr3lnfw7jGNbT6j9+4/ebm4dgB4H+VmFpIkGj+AueVtOhfdZrORBwzv2EwkyRZjj1h86y+W2HnO1h48ZROzCXZ5TGDTS7tsIXbAJmZiLBQeZd1+X8rb4ISWGpPAef09xN/eCy2ui9ThdDGD0Q51tY3gdnnB1eyBYHAAhoZG4PadeRidXgPfTyPg8gagoa4JdGoFqCSnQZb1TUqe/S2cyfxa4EoK80iVUgZ6hZQalFJmVheB21QCXXUV4LOooEYjBQfqkkML/noLmFUSMCvOQt35fHCUF4JWLoXyc9KUpkgK53LPClxTpYx4jApo1BbQVoOcBWrLoMNRDl31ldDvMUNfqxmrBS679NBmLYVWc0l6oMeihqtuEwSbq6BeK0s5zxdCjVoqcAFnBbniMoDfpqaBOi3rRFBHbQV0N1YhxABXLhjTEs0DXgv0NOvSg8QhPU06BJeCpUSaQoFJKRE4TEDCl+xiEoomJhr7MdUAGv5PKKq3RQ/NOgWunAvOChk0VRWDvawgfRaBCAOjIkfg8CEZumhFk4kiiImwIJp91Wrw4Hr/1VJo0SvAWpqH5tw0RPyWNZp8+OLEMTh96kTKi0l7GqsEDhOR6202wFVpm03DLhiVYMOH+uJscQWoxlVEgNiLMBFaXSoFnTwbgQWQ+flxePftt1LXfRaY6HIKnMekIm6jSoxNDcU5DGMzNDB7WT5zlBcwK/YIZBaUWI0KCTPgm3ptEWt3lLPPjn3IDh16JVWU9SVM9TYLnEUlCYnRMcELTEBtmjyKZ1ReWgiiRqVEHEbxDW2oLKI/OsroYKuBGovP0HfefIMefvXwy4/efw/6XLooh1PHGirl6TXFjyxK/L/EKq4kVkwDfqsaBluN8EuHHfgfbFCa8xW8dvQovJ6RARlHjsCnH38A7TZlksOpJtQtBN9A8dinJfZ2TR7vNsj5YGMFT9osfMhn5q95jHy/28BXyr7nM09+wmedOs7Lvzs5YlVkjbaZi73/Amd3/YNIVhGAAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "swept away",
          "title": "swept away",
          "src": "/static/2b05e75a31c4b3bc6d369147854b54bb/df1a7/TheGreatSand.png",
          "srcSet": ["/static/2b05e75a31c4b3bc6d369147854b54bb/fc834/TheGreatSand.png 345w", "/static/2b05e75a31c4b3bc6d369147854b54bb/36727/TheGreatSand.png 690w", "/static/2b05e75a31c4b3bc6d369147854b54bb/df1a7/TheGreatSand.png 1036w"],
          "sizes": "(max-width: 1036px) 100vw, 1036px",
          "loading": "lazy"
        }}></img>{`
    `}</span><center>{`Great Sand Dunes National Park and Preserve, Colorado 💨 💨`}</center></p>
    <p>{`I grew up being heavily influenced by the cultural idea of individualism. My driving motivational force was leveraged on the idea of what is now considered by Glassdoor and Harvard Business Review to be one of the most coveted job titles in the USA:👔 `}<strong parentName="p">{`Data Scientist`}</strong>{` 👔`}</p>
    <blockquote>
      <p parentName="blockquote">{`As a budding Data Scientist, I rely on the combination of statistics, computer science, and market research to maximize stakeholder’s interests.
I have an extensive background tailored to the financial services sector; working with a variety of financial data including market price data, corporate earnings data, and loan servicing data.`}</p>
    </blockquote>
    <p>{`I have private sector experience working for startups, family run businesses, and corporations.
I drive data science initiatives including the collection, processing, and deployment of data.
I try to understand the mechanics and technicalities of popular algorithms like decision trees and neutral networks to make assumptions about the economy.
I
hope to assemble (or be introduced to) a group of team members who wish to implement data science in the context of cognitive computing for forecasting capital markets.`}</p>
    <p>{`Call me directly if you think we might share interests:`}</p>
    <h2 {...{
      "id": "303-819-4867"
    }}><strong parentName="h2">{`(303) 819-4867`}</strong></h2>
    <h3 {...{
      "id": "lets-get-personal"
    }}>{`Let’s get personal…`}</h3>
    <h4 {...{
      "id": "i-come-from-a-place-where-the-great-plains-meet-the-rocky-mountains-on-the-colorado-front-range"
    }}>{`I come from a place where the Great Plains meet the Rocky Mountains on the Colorado Front Range:`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1380px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75.60503388189737%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAG3ELbGE4f/xAAYEAADAQEAAAAAAAAAAAAAAAAAAQISA//aAAgBAQABBQLUDrmagnLbmWsSf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABoQAQABBQAAAAAAAAAAAAAAAAAxEBEyQaH/2gAIAQEABj8C0nrJC1P/xAAaEAEAAgMBAAAAAAAAAAAAAAABACERMaGB/9oACAEBAAE/Iar7gbwIX0Y0jwTKAeERds//2gAMAwEAAgADAAAAEPff/8QAFREBAQAAAAAAAAAAAAAAAAAAECH/2gAIAQMBAT8Qp//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAECAQE/EIf/xAAcEAEAAwACAwAAAAAAAAAAAAABABEhQXGx0fD/2gAIAQEAAT8QvNcBeIBbqiO2w7IOUfriNgB5EfEqxruB6n//2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "home",
          "title": "home",
          "src": "/static/e980152c2cf24f8004ba539516195864/00650/frmtns.jpg",
          "srcSet": ["/static/e980152c2cf24f8004ba539516195864/0fa0d/frmtns.jpg 345w", "/static/e980152c2cf24f8004ba539516195864/8c996/frmtns.jpg 690w", "/static/e980152c2cf24f8004ba539516195864/00650/frmtns.jpg 1380w", "/static/e980152c2cf24f8004ba539516195864/bfc6b/frmtns.jpg 2070w", "/static/e980152c2cf24f8004ba539516195864/73c78/frmtns.jpg 2760w", "/static/e980152c2cf24f8004ba539516195864/79fcd/frmtns.jpg 4132w"],
          "sizes": "(max-width: 1380px) 100vw, 1380px",
          "loading": "lazy"
        }}></img>{`
    `}</span>{` `}<center>{`Pella Crossing, Colorado ❄️`}</center></p>
    <h4 {...{
      "id": "i-live-in-saint-petersburg-florida-where-the-pinnellas-peninsula-borders-tampa-bay"
    }}>{`I live in Saint Petersburg, Florida, where the Pinnellas Peninsula borders Tampa Bay:`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1380px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75.60503388189737%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAECAwT/xAAWAQEBAQAAAAAAAAAAAAAAAAACAAH/2gAMAwEAAhADEAAAAdCokwhGX//EABkQAAMBAQEAAAAAAAAAAAAAAAABAhEDEv/aAAgBAQABBQJWh0h5uQeYHzg//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BiP/EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/Aar/xAAYEAADAQEAAAAAAAAAAAAAAAAAATEQMv/aAAgBAQAGPwKreUQh/8QAGxAAAwACAwAAAAAAAAAAAAAAAAERITGRobH/2gAIAQEAAT8hlBjIzBUXgPTHaKt+T//aAAwDAQACAAMAAAAQIB//xAAVEQEBAAAAAAAAAAAAAAAAAAABAP/aAAgBAwEBPxBcT//EABYRAQEBAAAAAAAAAAAAAAAAAAABUf/aAAgBAgEBPxBt4//EABsQAQEBAQADAQAAAAAAAAAAAAERIQAxQXGx/9oACAEBAAE/ECgrMQb1YYfOYaEzphB9zjoL0PP4XhY03v8A/9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "new home",
          "title": "new home",
          "src": "/static/1a60e61d8b76aa7dfe084521d2feef0a/00650/fortdesoto.jpg",
          "srcSet": ["/static/1a60e61d8b76aa7dfe084521d2feef0a/0fa0d/fortdesoto.jpg 345w", "/static/1a60e61d8b76aa7dfe084521d2feef0a/8c996/fortdesoto.jpg 690w", "/static/1a60e61d8b76aa7dfe084521d2feef0a/00650/fortdesoto.jpg 1380w", "/static/1a60e61d8b76aa7dfe084521d2feef0a/bfc6b/fortdesoto.jpg 2070w", "/static/1a60e61d8b76aa7dfe084521d2feef0a/73c78/fortdesoto.jpg 2760w", "/static/1a60e61d8b76aa7dfe084521d2feef0a/79fcd/fortdesoto.jpg 4132w"],
          "sizes": "(max-width: 1380px) 100vw, 1380px",
          "loading": "lazy"
        }}></img>{`
    `}</span>{` `}<center>{`Fort Desoto Dog Park, Florida 🌊`}</center></p>
    {
      /* #### Now I continue to take the path less traveled hoping to find hidden data treasure with "me mateys":
      ![treasure](treasure.jpg) <center>Sawgrass Lake Park, Florida © Chris Rotunno 💰</center> */
    }
    <h4 {...{
      "id": "heres-scannon--my-great-companion"
    }}>{`Here’s Scannon—my great companion:`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "300px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "131.66666666666666%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAaABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBAv/EABcBAAMBAAAAAAAAAAAAAAAAAAABAgT/2gAMAwEAAhADEAAAAeG7ndEgSondUcGf/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAECESEDBBASQf/aAAgBAQABBQJbdNT0IlJKyzLI5O2Tzj//xAAWEQEBAQAAAAAAAAAAAAAAAAABECH/2gAIAQMBAT8BNhP/xAAYEQADAQEAAAAAAAAAAAAAAAAAARIQEf/aAAgBAgEBPwGmSzmf/8QAHRAAAQQCAwAAAAAAAAAAAAAAAQACEBEDMSAigf/aAAgBAQAGPwK3ZKXR59VbjRuSOP8A/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFBUXH/2gAIAQEAAT8hIWjmiISn7AFwNpDDEobRana6lQqpXK3BZV12pcNIbfkZ/9oADAMBAAIAAwAAABD42kD/xAAYEQEAAwEAAAAAAAAAAAAAAAABABARIf/aAAgBAwEBPxAK5AYsMK//xAAYEQEAAwEAAAAAAAAAAAAAAAABABARIf/aAAgBAgEBPxBXgQhja//EAB4QAQACAgIDAQAAAAAAAAAAAAEAESExQYFRYZGh/9oACAEBAAE/EHO2FnoddwJAPZ2OJ4JBJbBoLNSpRBkalAUWNbisuPI9uIARwNqWJxfz3FlYgCsqfoRI4Z//2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "dog",
          "title": "dog",
          "src": "/static/c97d519464d493364515f2f123dbe15e/afcd2/scannonhappyy.jpg",
          "srcSet": ["/static/c97d519464d493364515f2f123dbe15e/afcd2/scannonhappyy.jpg 300w"],
          "sizes": "(max-width: 300px) 100vw, 300px",
          "loading": "lazy"
        }}></img>{`
    `}</span>{` `}<center>{` Going for a walk 🐶`}</center></p>
    <h4 {...{
      "id": "heres-my-children--my-north-star"
    }}>{`Here’s my children—my north star:`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1380px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "67.74193548387096%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBBP/EABYBAQEBAAAAAAAAAAAAAAAAAAIAA//aAAwDAQACEAMQAAAB5bR3JWCv/8QAGxABAAICAwAAAAAAAAAAAAAAAQARAgMSIkH/2gAIAQEAAQUC8XrjrONsG4NH/8QAFREBAQAAAAAAAAAAAAAAAAAAECH/2gAIAQMBAT8Bh//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAEFAAAAAAAAAAAAAAAAAAABECFBYf/aAAgBAQAGPwI2yRH/AP/EABsQAQACAgMAAAAAAAAAAAAAAAEAESExQVGh/9oACAEBAAE/Iexm9TAAQeIwKbZxKplbWJrFn//aAAwDAQACAAMAAAAQDD//xAAZEQACAwEAAAAAAAAAAAAAAAAAAREhMUH/2gAIAQMBAT8Q4rBxNI//xAAWEQEBAQAAAAAAAAAAAAAAAAABECH/2gAIAQIBAT8QDZ//xAAeEAEAAgICAwEAAAAAAAAAAAABABEhMUFhUXGx0f/aAAgBAQABPxDOsiFuPP5M4TqqYGvpAOitDREsGcU8+4bFenUUAo5q5//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "children",
          "title": "children",
          "src": "/static/412281a0fec6e591957040491a64487d/00650/daughterspsnew.jpg",
          "srcSet": ["/static/412281a0fec6e591957040491a64487d/0fa0d/daughterspsnew.jpg 345w", "/static/412281a0fec6e591957040491a64487d/8c996/daughterspsnew.jpg 690w", "/static/412281a0fec6e591957040491a64487d/00650/daughterspsnew.jpg 1380w", "/static/412281a0fec6e591957040491a64487d/bfc6b/daughterspsnew.jpg 2070w", "/static/412281a0fec6e591957040491a64487d/73c78/daughterspsnew.jpg 2760w", "/static/412281a0fec6e591957040491a64487d/0ec0a/daughterspsnew.jpg 6200w"],
          "sizes": "(max-width: 1380px) 100vw, 1380px",
          "loading": "lazy"
        }}></img>{`
    `}</span>{` `}<center>{` Riley (left) and Bailey (right) 🌳`}</center></p>
    {
      /* [Back to Top](http://rotunno.io/about) */
    }
    <h4 {...{
      "id": "i-support-the-equal-rights-amendment-to-advocate-equal-rights-for-all-american-citizens-regardless-of-sex"
    }}>{`I support the `}<a parentName="h4" {...{
        "href": "https://www.equalrightsamendment.org/"
      }}>{`Equal Rights Amendment`}</a>{` to advocate equal rights for all American citizens regardless of sex.`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "193px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.55958549222798%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAJABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAgME/8QAFgEBAQEAAAAAAAAAAAAAAAAAAgAB/9oADAMBAAIQAxAAAAHrljaxUaBX/8QAGxAAAQQDAAAAAAAAAAAAAAAAAAECAxETMTL/2gAIAQEAAQUCfltHSj7E0T9//8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAIAQMBAT8BqP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB4QAAEEAQUAAAAAAAAAAAAAACEAAQIREhAiQVGB/9oACAEBAAY/Ap4t1QUtnACbJjWvi//EABwQAAEEAwEAAAAAAAAAAAAAAAEAETFBECFxgf/aAAgBAQABPyEmh2FP2kTvV3tPPAJtKPmI0//aAAwDAQACAAMAAAAQdO//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQMBAT8QGiQwC//EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oACAECAQE/EFf/xAAeEAEAAgEEAwAAAAAAAAAAAAABESEAEDGhsUFRgf/aAAgBAQABPxAbZBJAiEpYbz5+YVQJ0gpG3e5ofWBmkUALlzgutOI7c//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ERA",
          "title": "ERA",
          "src": "/static/145a95706d8113a242bc97fbf985d02c/e64da/equal.jpg",
          "srcSet": ["/static/145a95706d8113a242bc97fbf985d02c/e64da/equal.jpg 193w"],
          "sizes": "(max-width: 193px) 100vw, 193px",
          "loading": "lazy"
        }}></img>{`
    `}</span>{` `}<center>{`👱🏿‍♀️`}</center></p>
    <h4 {...{
      "id": "i-endorse-andrew-yang-as-the-democratic-nominee-for-the-president-of-the-united-states-in-2020"
    }}>{`I endorse `}<a parentName="h4" {...{
        "href": "https://twitter.com/AndrewYang"
      }}>{`Andrew Yang`}</a>{` as the Democratic nominee for the president of the United States in 2020.`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1380px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "24.71839799749687%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAFABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAECBf/EABUBAQEAAAAAAAAAAAAAAAAAAAIA/9oADAMBAAIQAxAAAAHCsKkBf//EABcQAAMBAAAAAAAAAAAAAAAAAAABERL/2gAIAQEAAQUCtKkaR//EABcRAQADAAAAAAAAAAAAAAAAAAABERL/2gAIAQMBAT8BtqX/xAAVEQEBAAAAAAAAAAAAAAAAAAAQQf/aAAgBAgEBPwGH/8QAFxABAQEBAAAAAAAAAAAAAAAAADIBMf/aAAgBAQAGPwLiUY//xAAZEAEAAgMAAAAAAAAAAAAAAAABABARITH/2gAIAQEAAT8hwXE2hDWf/9oADAMBAAIAAwAAABD3/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QEOkP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEhEf/aAAgBAgEBPxB2zD//xAAaEAACAgMAAAAAAAAAAAAAAAAAAREhMcHw/9oACAEBAAE/EGplU1Qs1F22RcaP/9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "forward",
          "title": "forward",
          "src": "/static/0ae13b02fdfbbebee12ae93c19d1a0b0/00650/Andrew_Yang_2020_logo.jpg",
          "srcSet": ["/static/0ae13b02fdfbbebee12ae93c19d1a0b0/0fa0d/Andrew_Yang_2020_logo.jpg 345w", "/static/0ae13b02fdfbbebee12ae93c19d1a0b0/8c996/Andrew_Yang_2020_logo.jpg 690w", "/static/0ae13b02fdfbbebee12ae93c19d1a0b0/00650/Andrew_Yang_2020_logo.jpg 1380w", "/static/0ae13b02fdfbbebee12ae93c19d1a0b0/33f33/Andrew_Yang_2020_logo.jpg 1598w"],
          "sizes": "(max-width: 1380px) 100vw, 1380px",
          "loading": "lazy"
        }}></img>{`
    `}</span>{` `}<center>{`➕➖✖️➗`}</center></p>
    <p><a parentName="p" {...{
        "href": "http://rotunno.io/"
      }}>{`Back to Blog`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      